import instance from "./Instance/index.js";

export const createPost = async (values) => {
  try {
    const response = await instance.post(`/posts`, values);
    return response;
  } catch (err) {
    throw err;
  }
};

export const getPosts = async () => {
  try {
    const response = await instance.get(`/posts`);
    return response;
  } catch (err) {
    throw err;
  }
};

export const getSidebarPosts = async () => {
  try {
    const response = await instance.get(`/posts/side/posts`);
    return response;
  } catch (err) {
    throw err;
  }
};

export const getPost = async (id) => {
  try {
    const response = await instance.get(`/posts/${id}`);
    return response;
  } catch (err) {
    throw err;
  }
};

export const searchPosts = async (values) => {
  try {
    const response = await instance.post(`/posts/search`, values);
    return response;
  } catch (err) {
    throw err;
  }
};

export const updatePost = async (id, values) => {
  try {
    const response = instance.put(`/posts/${id}`, values);
    return response;
  } catch (err) {
    throw err;
  }
};

export const deletePost = async (id) => {
  try {
    const response = await instance.delete(`/posts/${id}`);
    return response;
  } catch (err) {
    throw err;
  }
};
